<template>
  <div class="selected-articles-list">
    <div class="header">
      <h4 class="count">เลือกแล้ว {{ count }} ข่าว</h4>
      <sc-button
        v-if="showRemoveAllButton"
        :disabled="disabledRemoveButton"
        class="remove-all-button"
        @click="handleClickRemoveAllButton"
        >ลบทั้งหมด</sc-button
      >
    </div>
    <div class="list-body">
      <div v-if="isEmpty" class="empty">ไม่มีข่าวที่เลือก</div>
      <draggable
        v-model="sortedValue"
        v-bind="dragOptions"
        class="list"
        @end="handleDragEnd"
      >
        <articles-selector-option
          v-for="item in sortedValue"
          :key="item.id"
          v-bind="item"
          :can-remove="canRemove"
          class="selected-item"
          @remove="handleRemoveSelectService(item)"
        ></articles-selector-option>
      </draggable>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable"
import ScButton from "@/lib/components/ScButton"
import ArticlesSelectorOption from "./ArticlesSelectorOption"

export default {
  components: {
    draggable,
    ArticlesSelectorOption,
    ScButton,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      sortedValue: [],
    }
  },
  computed: {
    isEmpty() {
      return this.value.length === 0
    },
    count() {
      return this.value.length
    },
    disabledRemoveButton() {
      return this.isEmpty || !this.canRemove
    },
    canRemove() {
      return !this.disabled
    },
    showRemoveAllButton() {
      return this.canRemove
    },
    dragOptions() {
      return {
        animation: 200,
        disabled: this.disabled,
        ghostClass: "ghost",
      }
    },
  },
  watch: {
    value(newVal) {
      this.sortedValue = newVal
    },
  },
  created() {
    this.setup()
  },
  methods: {
    setup() {
      this.sortedValue = this.value
    },
    handleRemoveSelectService(service) {
      this.$emit("remove", service)
    },
    handleClickRemoveAllButton() {
      this.$emit("removeAll")
    },
    handleDragEnd() {
      this.$emit("sortedValue", this.sortedValue)
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.selected-articles-list {
  border: $border;
  border-radius: $border-radius;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.list {
  padding-bottom: 15px;
  overflow: auto;
  cursor: grabbing;
}

.header {
  display: grid;
  grid-template-columns: 1fr auto;

  border-bottom: $border;

  > .remove-all-button {
    height: 42px;
    font-size: 0.8rem;
    color: #444;
    border: 0;
    border-radius: 0;
    border-top-right-radius: $border-radius;
    border-left: $border;

    &:hover,
    &:focus {
      border-color: #dcdfe6 !important;
    }
  }
}

.selected-articles-list > .list-body {
  overflow-y: auto;
  height: 500px;
}

.empty {
  padding: 20px 0;
  text-align: center;
}

.count {
  margin: 0;
  padding: 10px ($space / 2);

  color: $primary-color;
  font-size: 1.1rem;
  font-weight: bold;
}
</style>
